var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"production-scheduling-item-container",class:{'disabled': _vm.itemData.wipEntityName, 'error': _vm.itemData.orderNo === _vm.errorOrderNo || _vm.isLineLoseEfficacy},on:{"click":_vm.handleItemClick}},[_c('span',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.itemData.orderQuantity))])])
}
var staticRenderFns = []

export { render, staticRenderFns }